module.exports = __webpack_public_path__ + "static/media/8.601b3642.jpg";